import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Locker } from '@sorare/core/src/atoms/icons/Locker';
import { Unlock } from '@sorare/core/src/atoms/icons/Unlock';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';

const UnlockIcon = styled(Unlock)`
  color: var(--c-rivals-win);
`;
const LockIcon = styled(Locker)`
  color: var(--c-yellow-400);
`;

type Props = { publiclyAccessible: boolean };
export const VisibilityLabel = ({ publiclyAccessible }: Props) => {
  if (publiclyAccessible) {
    return (
      <Horizontal>
        <UnlockIcon />
        <LabelL bold>
          <FormattedMessage
            id="Squad.InviteDialog.public"
            defaultMessage="Public"
          />
        </LabelL>
      </Horizontal>
    );
  }

  return (
    <Horizontal>
      <LockIcon />
      <LabelL bold>
        <FormattedMessage
          id="Squad.InviteDialog.private"
          defaultMessage="Private"
        />
      </LabelL>
    </Horizontal>
  );
};
